"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsEvent = void 0;
// Événements analytics (migration de PlausibleEvents)
var AnalyticsEvent;
(function (AnalyticsEvent) {
    // Session lifecycle
    AnalyticsEvent["SESSION_STARTED"] = "session_started";
    AnalyticsEvent["SESSION_ENDED"] = "session_ended";
    AnalyticsEvent["SESSION_CANCELLED"] = "session_cancelled";
    // User interactions
    AnalyticsEvent["IDLE_MODAL_RENDERED"] = "idle_modal_rendered";
    AnalyticsEvent["LOGOUT_FROM_IDLE_MODAL"] = "logout_from_idle_modal";
    // Interview
    AnalyticsEvent["STARTED_INTERVIEW"] = "started_interview";
    AnalyticsEvent["ENDED_INTERVIEW"] = "ended_interview";
    // CV actions
    AnalyticsEvent["DOWNLOADED_CV"] = "downloaded_cv";
    AnalyticsEvent["PRINTED_CV"] = "printed_cv";
    AnalyticsEvent["REACHED_PRINT_STEP"] = "reached_print_step";
    // Jobs
    AnalyticsEvent["JOB_LISTED"] = "job_listed";
    AnalyticsEvent["JOB_CARD_CLICKED"] = "job_card_clicked";
    AnalyticsEvent["APPLY_TO_JOB"] = "apply_to_job";
    AnalyticsEvent["JOBS_LIST_SCREEN_RENDERED"] = "jobs_list_screen_rendered";
    // Registration & Payment
    AnalyticsEvent["NEXT_REGISTER_STEP"] = "next_register_step";
    AnalyticsEvent["PAYMENT_SUCCEEDED"] = "payment_succeeded";
    /** Emitted when payment is captured (debited) at end of interview (CV generation). */
    AnalyticsEvent["PAYMENT_CAPTURED"] = "payment_captured";
})(AnalyticsEvent || (exports.AnalyticsEvent = AnalyticsEvent = {}));
